
import React, { PureComponent } from 'react'
import { Button, Modal, Col } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../commons/form/InputText'
import InputTreeSelect from '../../commons/form/InputTreeSelect'
import SimpleTablePage from '../../../containers/commons/general/SimpleTablePage'
import { handleKeyDown } from '../../../util/utils'

class PurchasePresentTypeModal extends PureComponent {
  submitPurchasePresentType (values) {
    let organizedUnitId = null
    const body = []
    Object.keys(values).map(item => {
      body.push(values[item])
      if (typeof values[item] !== 'object') {
        organizedUnitId = values[item]
      }
    })
    this.props.actions.savePurchasePresentTypeModal(organizedUnitId, body, this.props.purchasePresentTypeId)
  }

  render () {
    const { t, showPurchasePresentTypeModal, handleSubmit, languageList = [], combos: { UOTreeCombo } } = this.props
    return (
      <Modal id="purchasePresentTypeModal" show={showPurchasePresentTypeModal} onHide={this.props.actions.closePurchasePresentTypeModal} className="_nf">
        <Modal.Header closeButton>
          <Modal.Title>{t('MASTERS.PURCHASE_PRESENT_TYPE_MASTERS.ADD_PURCHASE_PRESENT')}</Modal.Title>
        </Modal.Header>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitPurchasePresentType.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Body>
            <div className="search-form auto z-2">
              <Field
                component={InputTreeSelect}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                name="organizedUnitId"
                controlLabel={t('MASTERS.PURCHASE_PRESENT_TYPE_MASTERS.ORGANIZED_UNIT')}
                placeholder={t('MASTERS.PURCHASE_PRESENT_TYPE_MASTERS.ORGANIZED_UNIT')}
                multi={false}
                allowClear={false}
                valueKey="value"
                labelKey="label"
                childrenKey="children"
                options={UOTreeCombo}
              />
            </div>
            <SimpleTablePage
              // customClass={'langTable'}
              columns={[
                <th className='colWidth-15 alignC' key={2}>
                  {t('MASTERS.LANGUAGE')}
                </th>,
                <th className='colWidth-30' key={0}>
                  {t('MASTERS.NAME')}
                </th>,
                <th className='colWidth-55' key={1}>
                  {t('MASTERS.DESCRIPTION')}
                </th>
              ]}
              rows={languageList && languageList.map((val, idx) => (
                <tr key={idx}>
                  <td className='alignC'>
                    <p><span>{`${val.description}`}</span></p>
                    <p>{`(${val.name})`}</p>
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.name`}
                      placeholder={t('MASTERS.NAME')}
                      maxLength={50}
                    />
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.description`}
                      placeholder={t('MASTERS.DESCRIPTION')}
                      maxLength={100}
                    />
                  </td>
                </tr>
              ))}
            />
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button type="submit" className="_Btn new">
                {t('MASTERS.SAVE')}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}
const validate = (values, props) => {
  const errors = {}
  props.languageList.map(language => {
    errors[`lang${language.languageId}`] = {}
    if (values[`lang${language.languageId}`] !== undefined) {
      if (!(values[`lang${language.languageId}`].name)) {
        errors[`lang${language.languageId}`].name = props.t('MASTERS.VALIDATION.NAME_REQUIRED')
      }
      if (!(values[`lang${language.languageId}`].description)) {
        errors[`lang${language.languageId}`].description = props.t('MASTERS.VALIDATION.DESCRIPTION_REQUIRED')
      }
    } else {
      errors[`lang${language.languageId}`].name = props.t('MASTERS.VALIDATION.NAME_REQUIRED')
      errors[`lang${language.languageId}`].description = props.t('MASTERS.VALIDATION.DESCRIPTION_REQUIRED')
    }
  })
  return errors
}
export default reduxForm({
  form: 'editPurchasePresentType',
  validate
})(PurchasePresentTypeModal)
